import styled from 'styled-components'
import { colors, scale } from '../../styles'
import { CustomInputInner, LabelStyledProps, LabelTextStyled } from './FilterCheckbox'
import { Icon } from '../Icon'

export interface FilterCheckboxInlineProps {
	onChange?: React.ChangeEventHandler<HTMLInputElement>
	disabled?: boolean
	id?: string
	name?: string
	value?: string
	checked?: boolean
	label?: string
	inputRef?: React.Ref<HTMLInputElement>
	hits?: number
	defaultChecked?: boolean
	unitFilter?: boolean
}

const LabelInlineStyled = styled.label<LabelStyledProps & { unitFilter: boolean }>`
	position: relative;
	display: inline-flex;
	cursor: pointer;
	user-select: none;
	font-size: ${scale.px(1.75)};
	line-height: ${scale.px(2)};
	font-weight: bold;
	color: ${colors.navy};
	top: -7px;
	margin-left: ${({ unitFilter }) => (unitFilter ? 0 : scale.px(1))};
`

const CustomInputInnerInline = styled.div`
	display: flex;
	align-items: center;
	padding: ${scale.px(1)};

	// Checkbox square
	&:before {
		content: "";
		display: inline-block;
		width: ${scale.px(1.5)};
		height: ${scale.px(1.5)};
		border-radius: 2px;
		border: 1px solid ${colors.navy};
	}
`
const CustomInputInlineStyled = styled.div<{ unitFilter: boolean }>`
	position: relative;
	background-color: ${({ unitFilter }) => (unitFilter ? 'transparent' : colors.white)};
	border:  1px solid transparent;
	border-radius: ${scale.px(0.5)};

	// Checkbox checkmark
	svg {
		position: absolute;
		top: 29%;
		left: ${scale.px(.75)};
		opacity: 0;
	}

	&:hover {
		color: ${colors.hoverBlue};

		${CustomInputInner} {
			:before {
				border-color: ${colors.hoverBlue};
			}
		}
	}
`

const InputInlineStyled = styled.input.attrs({ type: "checkbox" })`
	border: 0;
	outline: 0;
	height: 1px;
	margin: -1px;
	overflow: hidden;
	padding: 0;
	position: absolute;
	white-space: nowrap;
	width: 1px;

	&:focus + ${CustomInputInlineStyled} {
		border: 1px solid ${colors.hoverBlue};

		${LabelTextStyled} {
			color: ${colors.hoverBlue};
		}
	}

	&:checked + .checkbox {
		svg {
			fill: ${colors.white};
			opacity: 1;
		}

		${CustomInputInner}:before {
			border-color: ${colors.navy};
		}
	}
`

const FilterCheckboxInline: React.FC<FilterCheckboxInlineProps> = ({
	label,
	id,
	disabled,
	inputRef,
	hits,
	...rest
}) => (
	<LabelInlineStyled disabled={disabled} htmlFor={id} unitFilter={rest.unitFilter}>
		<InputInlineStyled ref={inputRef} id={id} disabled={disabled} {...rest} />
		<CustomInputInlineStyled className="checkbox" unitFilter={rest.unitFilter}>
			<Icon icon="check" size={2} color="navy" />
			<CustomInputInnerInline>
				<LabelTextStyled>
					{label}
					{hits && ` (${hits})`}
				</LabelTextStyled>
			</CustomInputInnerInline>
		</CustomInputInlineStyled>
	</LabelInlineStyled>
)

export { FilterCheckboxInline }